// BANNER PODS

jQuery(document).ready(function ($) {

  $('.c-banner-pod--content .moon-plus3').click(function () {
    $(this).parent('.c-banner-pod--content').toggleClass('active');
  });
  
});
